<template>
	<div class="group">
		<div class="top">
			<div>CEMAX(10/100)
				<svg class="icon" aria-hidden="true" style="width: 20px;height: 20px;vertical-align: bottom;">
					<use xlink:href="#icon-lingdang1" fill="#217ECD"></use>
				</svg>
			</div>

			<div style="width: 100%;margin-top: 20px;">

				<Input v-model="value14" placeholder="Enter something..." clearable style="width: 80%;height: 40px;" />

				<svg class="icon" aria-hidden="true" style="width: 20px;height: 20px;">
					<use xlink:href="#icon-sousuo" fill="#217ECD"></use>
				</svg>


			</div>

		</div>

		<div class="center">
			<div class="persionGroup">
				<div style="z-index: 2;" class="leader" @click="openGroup">
					<span>{{$tt('押解组A')}}</span>
					<Icon type="ios-paper" color="#217ECD" />
					<Badge style="margin-left: 10px;" :count="10"></Badge>
				</div>
				<transition name="slide-fade">
					<!-- <div v-show="openId==1 ? 'ifDisplay' : ''" :class="['groupPer',openId==1 ? 'ifDisplay' : '']">111</div> -->
					<div style="z-index: 1;" v-show="openId==1 ? true : false" class="groupPer">
						<div class="groupPer_">
							<svg class="icon" aria-hidden="true" style="width: 15px;height: 20px; vertical-align: bottom;">
								<use xlink:href="#icon-police" fill="#217ECD"></use>
							</svg>&nbsp;&nbsp;
							<span @click="openGroupInfo">{{$tt('张三(负责人)')}}</span>
						</div>
						<div class="groupPer_">
							<svg class="icon" aria-hidden="true" style="width: 15px;height: 20px; vertical-align: bottom;">
								<use xlink:href="#icon-shoukao" fill="#217ECD"></use>
							</svg>{{$tt('&nbsp;&nbsp;李四(犯人)')}} <Badge style="margin-left: 10px;" :count="3"></Badge>
						</div>
						<div class="groupPer_">
							<svg class="icon" aria-hidden="true" style="width: 15px;height: 20px; vertical-align: bottom;">
								<use xlink:href="#icon-shoukao" fill="#217ECD"></use>
							</svg>{{$tt('&nbsp;&nbsp;王五(犯人)')}} <Badge style="margin-left: 10px;" :count="3"></Badge>
						</div>
						<div class="groupPer_">
							<svg class="icon" aria-hidden="true" style="width: 15px;height: 20px; vertical-align: bottom;">
								<use xlink:href="#icon-shoukao" fill="#217ECD"></use>
							</svg>{{$tt('&nbsp;&nbsp;赵六(犯人)')}} <Badge style="margin-left: 10px;" :count="4"></Badge>
						</div>

					</div>
				</transition>
			</div>
			<div class="persionGroup">
				<div class="leader" @click="openGroup">{{$tt('押解组B')}}</div>
				<transition name="slide-fade">
					<!-- <div v-show="openId==1 ? 'ifDisplay' : ''" :class="['groupPer',openId==1 ? 'ifDisplay' : '']">111</div> -->
					<div v-show="openId==2 ? true : false" class="groupPer">
						<p>{{$tt('张三')}}</p>
						<p>{{$tt('李四')}}</p>
						<p>{{$tt('王五')}}</p>
					</div>
				</transition>
			</div>

			<div class="persionGroup">
				<div class="leader" @click="openGroup">{{$tt('押解组C')}}</div>
				<transition name="slide-fade">
					<!-- <div v-show="openId==1 ? 'ifDisplay' : ''" :class="['groupPer',openId==1 ? 'ifDisplay' : '']">111</div> -->
					<div v-show="openId==3 ? true : false" class="groupPer">
						<p>{{$tt('张三')}}</p>
						<p>{{$tt('李四')}}</p>
						<p>{{$tt('王五')}}</p>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
	// import gaodeMap from "../../../js/GaodeMapMethod.js"
	export default {

		data() {
			return {
				alarmBoolean: false,
				value14: '',
				openId: 1,
				selected: [{
						position: [114.0342725000, 22.6184668200],
						type: 'Leader',
						deviceId: '123456'
					},
					{
						position: [114.0300865000, 22.6180248200],
						type: 'MonitoringObject',
						deviceId: '123456'
					},
					{
						position: {
							lat: 22.6184668200,
							lng: 114.0342725000
						},
						type: 'MonitoringObject',
						deviceId: '123456'
					}
				]
			}
		},
		mounted() {

		},
		methods: {
			openGroupInfo: function() {
				this.$emit("openGroupInfo")
			},
			openGroup: function() {
				const _this = this;
				if (_this.openId != 6) {

					_this.openId = 6
				} else {
					_this.openId = 1
				}

				//打开押解组的同时显示押解组设备定位在地图
				// gaodeMap.createMarkeList(this.selected);

			}


		}
	}
</script>

<style>
	.group {
		width: 12%;
		height: 100%;
		position: absolute;
		z-index: 1;
		/* background-color: black; */
		background-color: #191730;

	}
	.top {
		width: 97%;
		height: 80px;
		margin: 10px auto;
		color: white
	}
	.leader {
		width: 99%;
		height: 50px;
		line-height: 50px;
		font-size: 15px;
		text-align: left;
		padding-left: 10px;
	}
	.groupPer {
		width: 99%;

		text-align: left;
		padding-left: 10px;
		font-size: 13px;

	}
	.leader,
	.groupPer {
		color: #65CE90;
		background-color: #23223F;
	}
	.groupPer_ {
		margin-bottom: 5px;
		margin-left: 2px;
	}
	.ifDisplay {
		display: none;
	}
	.persionGroup {
		margin-bottom: 5px;
		padding: 0 5px;
	}
	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	/**
		 * 1.在元素被插入之前生效，在元素被插入之后的下一帧移除。
		 * 2.在整个进入过渡的阶段中应用，在元素被插入之前生效，在过渡/动画完成之后移除。
		 * 3.在元素被插入之后下一帧生效 (与此同时 v-enter 被移除)，在过渡/动画完成之后移除。
		 * 
		 * 4.在离开过渡被触发时立刻生效，下一帧被移除。
		 * 5.在整个离开过渡的阶段中应用，在离开过渡被触发时立刻生效，在过渡/动画完成之后移除。
		 * 6.在离开过渡被触发之后下一帧生效 (与此同时 v-leave 被删除)，在过渡/动画完成之后移除。
		 * 
		 */
	.slide-fade-enter {
		transform: translateY(-30px);
		opacity: 0;
	}
	.slide-fade-enter-active {
		transition: all .5s ease;
	}
	.slide-fade-enter-to {
		
	}
	.slide-fade-leave {
		
	}
	.slide-fade-leave-active {
		transition: all .5s ease;
	}
	.slide-fade-leave-to
	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateY(-5px);
		opacity: 0;

	}
</style>
